import React from 'react';
import {Accordion, AccordionDetails, AccordionSummary} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Typography from "@mui/material/Typography";
import parse from "html-react-parser";
import {BaseStyle} from "../../../styles/shared/BaseStyle";
import clsx from "clsx";

const AccordionFaq = ({domanda, risposta, actions, contattaci = false}) => {
	const classes = BaseStyle();
	
	return (
		<React.Fragment>
			<Accordion
				className={
					contattaci ?
						clsx(classes.roundAccordion, classes.transparent80, classes.blurred20) :
						clsx(classes.roundAccordion)
				}
				style={{borderRadius: 24}}>
				<AccordionSummary
					expandIcon={<ExpandMoreIcon/>}
				>
					<Typography className={classes.heading}><b>{domanda}</b></Typography>
				</AccordionSummary>
				<AccordionDetails style={{display: "block"}}>
					<Typography variant={"subtitle1"} component={"div"} color="textSecondary">
						{
							parse(risposta)
						}
					</Typography>
				</AccordionDetails>
				{
					actions && actions
				}
			</Accordion>
		</React.Fragment>
	);
};

export default React.memo(AccordionFaq);
